import { createSvg } from '@r1-frontend/ui-kit/atoms/svg/createSvg';

const Add = ({ strokeWidth = 1.5 }): JSX.Element => {
    return (
        <>
            <g id={'guts'}>
                <path
                    d='M6 12H18'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M12 18V6'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
        </>
    );
};

export default createSvg(
    Add,
    'add',
);
